import { render } from "./ApprovedPrs.vue?vue&type=template&id=331a658c"
import script from "./ApprovedPrs.vue?vue&type=script&lang=js"
export * from "./ApprovedPrs.vue?vue&type=script&lang=js"

import "./ApprovedPrs.vue?vue&type=style&index=0&id=331a658c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__